import { PressRelease, PressReleaseImage } from "@clients/afaseApiClient";
import { ImageType } from "@utils/imageHelpers/imageHelper";
import { isNullOrEmpty } from "@utils/string";

import { PressReleaseListEntry } from "types/PressReleaseListEntry";

const getListImage = (pressRelease: PressRelease): PressReleaseImage | null => {
  if (pressRelease?.images) {
    return (
      pressRelease.images[ImageType.metaImage] || pressRelease.images[ImageType.mainImage] || null
    );
  }
  return pressRelease?.mainImage ?? null;
};

/**
 * Reduces full press releases (including body) to the fields needed by list blocks.
 * Press releases without slug are dropped since they cannot be linked to.
 */
export const mapPressReleasesToListEntries = (
  pressReleases: Array<PressRelease>,
): Array<PressReleaseListEntry> =>
  (pressReleases ?? [])
    .filter((pressRelease) => !isNullOrEmpty(pressRelease?.slug))
    .map((pressRelease) => {
      const image = getListImage(pressRelease);
      return {
        id: pressRelease.id,
        slug: pressRelease.slug,
        heading: pressRelease.heading ?? null,
        text: pressRelease.summary || pressRelease.preamble || null,
        publishDate: pressRelease.publishDate ?? null,
        imageUrl: image?.url ?? null,
        imageAltText: image?.caption ?? null,
      };
    });
